module.exports = __webpack_public_path__ + "static/media/2016_conf_Productization_Mindset.2167806d.png";